<template>
  <v-card
    flat
    class="ma-0 pa-0"
    color="rgba(255, 0, 0, 0)"
  >
    <v-switch
      v-model="dotModeData"
      label="DotMode"
    />
    <VTextarea
      v-if="!dotModeData"
      v-model="json"
      v-bind="textAreaProps"
    />
    <VTextarea
      v-else
      v-model="dotString"
      v-bind="textAreaProps"
    />
  </v-card>
</template>

<script>
// const dot = require('dot-object')
import dot from 'dot-object'
export default {
  props: {
    value: {
      type: [Array, Object],
      required: true
    },
    dotMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        json: v => this.validateJson(v) || 'Please enter a valid JSON'
      },
      dotModeData: false
    }
  },
  computed: {
    json: {
      get () {
        return JSON.stringify(this.value, null, 2)
      },
      set (newVal) {
        try {
          this.$emit('input', JSON.parse(newVal))
        } catch {
        }
      }
    },
    dotString: {
      get () {
        return JSON.stringify(dot.dot(this.value), null, 2)
      },
      set (newVal) {
        try {
          this.$emit('input', dot.object(JSON.parse(newVal)))
        } catch {

        }
      }
    },
    comLabel () {
      if ('readonly' in this.$attrs) return this.$attrs.label + ' (readonly)'
      return this.$attrs.label
    },
    textAreaProps () {
      return {
        label: this.comLabel,
        rules: [this.rules.json],
        autoGrow: true,
        outlined: true,
        ...this.$attrs
      }
    }
  },
  mounted () {
    this.dotModeData = this.dotMode
  },
  methods: {
    validateJson (json) {
      try {
        JSON.parse(json)
        return true
      } catch {
        return false
      }
    }
  }
}
</script>

<style>

</style>
